import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIConnector } from '@desbank/core/src/lib/services/api';
import { Observable } from 'rxjs';
import { UserAccessHistory } from './interfaces/user-access-history.interface';


@Injectable({
  providedIn: 'root'
})
export class LoginApiService {

  constructor(
    private apiConnector: APIConnector
  ) {}

  public getPublicKey(): Observable<any> {
    return this.apiConnector.get('Key/public-key');
  }

  public auth(data: string, captchaToken: string): Observable<any> {
    return this.apiConnector.post('Auth/login-rsa', {data}, new HttpHeaders({'g-recaptcha-response': captchaToken}));
  }

  public sendUserAccessHistory(userAccessHistory: UserAccessHistory): Observable<any> {
    return this.apiConnector.post('Auth/PostUserAccessHistory', userAccessHistory);
  }

  public refreshToken(token: string): Observable<any> {
    return this.apiConnector.post(`Auth/RefreshLogin/${token}`, {});
  }
}
